import React from "react";
import { useSelector } from "react-redux";
import { Row, Container, Col } from "react-bootstrap";
import "../CodeOverview/CodeOverview.scss";
import ReactMarkdown from "react-markdown";
import Scrollbars from "react-custom-scrollbars-2";

function Documentation() {
  const documentationData = useSelector((state) => state.CodeDocumentation?.documentation);

  return (
    <div className="page-wrapper code-overview-page px-3">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">Code Documentation</h2>
            <div className="code-overview-wrapper">
              {documentationData && (
                <>
                  <Row>
                    <Col>
                      <div className="overview-text-wrapper">
                        <Scrollbars>
                          <ReactMarkdown className="overview-text">
                            {documentationData}
                          </ReactMarkdown>
                        </Scrollbars>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Documentation;